import React, { useRef, useState } from "react";
import { Link } from "react-router-dom";
const ProductCarousel = ({ data }) => {
  const scrollRef = useRef(null);

  const handleMouseEnter = () => {
    if (scrollRef.current) {
      scrollRef.current.style.animationPlayState = "paused";
    }
  };

  const handleMouseLeave = () => {
    if (scrollRef.current) {
      scrollRef.current.style.animationPlayState = "running";
    }
  };

  return (
    <div className="w-full flex justify-center bg-[rgba(239,238,255,.61)] ">
      <div className="flex relative w-full overflow-hidden ">
        <div
          ref={scrollRef}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
          className="flex w-clientcarousel gap-5 animate-scroll"
        >
          {Array.from({ length: data.products.length }, (_, index) => (
            <div
              key={index}
              className="min-w-fit max-w-[200px] flex justify-center gap-5"
              style={{}}
            >
              {data.products.map((el, i) => (
                <Link to={el.url} key={i} className=" px-6 py-5 ">
                  <div className="flex flex-col gap-4 mb-2">
                    <div className="rounded-full productlogo">
                      <img
                        src={process.env.PUBLIC_URL + el.icon}
                        alt="pdficon"
                        className="text-white"
                      />
                    </div>
                  </div>
                  <div className="text-primarycolor  flex flex-row gap-3 w-[200px] productlist relative">
                    <p className="text-14 text-primarycolor">
                      {el.productdesc}
                    </p>
                  </div>
                </Link>
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProductCarousel;
